import React from "react";

const SidebarModelsLoading = ({ cardCount = 8 }) => {
    return (
        <div className="item_loader_body_sidebar">
            {Array.from({ length: cardCount }).map((_, index) => (
                <div key={index} className="item_loader_body_sidebar_card fade-in" />
            ))}
        </div>
    );
};

export default SidebarModelsLoading;